import { render, staticRenderFns } from "./ActionCollaborativeReponses.vue?vue&type=template&id=7cfcd728&"
import script from "./ActionCollaborativeReponses.vue?vue&type=script&lang=js&"
export * from "./ActionCollaborativeReponses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VImg,VProgressLinear})
